import React, { CSSProperties, FC } from 'react';
import { IconName, NonIdealState } from '@blueprintjs/core';

interface StaticWelcomeStageProps {
    icon: IconName
}

export const StaticWelcomeStage: FC<StaticWelcomeStageProps> = props => {
    const outerStyle: CSSProperties = {
        width: '100%',
        height: '100%',
        position: 'relative'
    };
    const openStyle: CSSProperties = {
        position: 'absolute',
        top: '1em',
        right: '1em'
    };
    const viewStyle: CSSProperties = {
        position: 'absolute',
        top: '1em',
        left: '2em'
    };
    const welcomeStyle: CSSProperties = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translateX(-50%) translateY(-50%)'
    };
    return (
        <div style={outerStyle}>
            <div style={openStyle}>
                <NonIdealState
                    icon={'arrow-top-right'}
                    title={'Open an Instance'}
                    description={<>Click the Open button to choose an<br/>example instance or upload your own.</>}/>
            </div>
            <div style={viewStyle}>
                <NonIdealState
                    icon={'arrow-up'}
                    title={'Explore Views'}
                    description={<>
                        The Graph, Table, and Script views each<br/>provide a different way of visualizing
                        an instance.<br/>The Source view contains the Alloy model source<br/>code used to generate the instance.
                    </>}/>
            </div>
            <div style={welcomeStyle}>
                <NonIdealState
                    icon={props.icon}
                    title={'Welcome to Sterling'}
                    description={<>
                        Open an example instance to begin exploring Sterling.
                        Each example instance includes a custom visualization script that can be executed in the
                        Script view.
                    </>}/>
            </div>
        </div>
    )
}

